import { cast, LocalDateTime } from "@flockcover/flock-svc-core-types"
import { Trip as Result } from "@shared/platform-api/generated"
import { kmToMileConverterWithDecimals } from "@shared/utils/formatters/kmToMiles"
import { UUID } from "io-ts-types/lib/UUID"
import { getSpeedBands, getSpeedingPercentage, setMaximumDecimalPlaces } from "../utils"
import { vehicleFromApi } from "../vehicles"
import { Trip, TripWithGeoJson } from "./types"

export const fromApi = (
  result: Result & {
    hereGeojsonUrl?: string | undefined
    geoJsonStringContent?: string | undefined
  }
): TripWithGeoJson | Trip => {
  const speedBands = getSpeedBands(
    result.analytics.minorSpeedBandPercentage,
    result.analytics.majorSpeedBandPercentage,
    result.analytics.criticalSpeedBandPercentage
  )

  const distance = kmToMileConverterWithDecimals(result.analytics.distanceKm, 1)
  const totalSpeedingPercentage = getSpeedingPercentage(speedBands)
  const unsafeMiles = distance && totalSpeedingPercentage ? distance * totalSpeedingPercentage : 0

  return {
    id: cast(UUID)(result.id),
    startedAt: cast(LocalDateTime)(result.startedAt),
    finishedAt: cast(LocalDateTime)(result.finishedAt),
    vehicle: vehicleFromApi(result.vehicle),
    analytics: {
      distance,
      distanceSpentSpeeding: totalSpeedingPercentage,
      unsafeMiles: setMaximumDecimalPlaces(unsafeMiles, 1),
      safeMiles: setMaximumDecimalPlaces(distance - unsafeMiles, 1),
      averageSpeedExceedencePercentage: result.analytics.averageSpeedExceedencePercentage,
      speedBands,
      score: result.analytics.safetyScore ?? null,
    },
    geojsonUrl: result.hereGeojsonUrl!,
    geoJsonStringContent: result.geoJsonStringContent,
  }
}
